import apibase from './BaseAPI';

const id = async (id) => {
    const url = `/master/properties/${id}`;
    try {
        const result = await apibase.get(url);
        return result.data;
    } catch (err) {
        throw err;
    }
};

const isNameUnique = async (name) => {
    let trimmedString = name ? name.trim() : null;
    const params = {
        name: trimmedString
    };
    const url = `/master/properties/isNameUnique`;
    try {
        const result = await apibase.post(url, params);
        return result.data;
    } catch (err) {
        throw err;
    }
};

const keyValue = async (search) => {
    const params = {
        search: search
    };
    const url = `/master/properties/keyValue`;
    try {
        const result = await apibase.post(url, params);
        return result.data;
    } catch (err) {
        throw err;
    }
};


export default {
    id,
    isNameUnique: isNameUnique,
    keyValue: keyValue
};